import { Box, alpha, styled } from '@mui/material';

export const StyledActionsBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(0, 1.5),
  '.showActions': {
    '.message-actions': {
      visibility: 'visible',
    },
  },
  '.goToMessage': {
    backgroundColor: alpha(theme.palette.primary.main, 0.48),
  },
  '.message-actions': {
    visibility: 'hidden',
  },
  '.message-time': {
    fontSize: 8,
    visibility: 'hidden',
  },
  '&:hover, &.isOptionsOpen, &.isOpened': {
    backgroundColor: theme.palette.background.neutral,

    '.message-time': {
      visibility: 'visible',
    },
    '&:not(.editing) .message-actions': {
      visibility: 'visible',
    },
  },
}));
